import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { FieldTextRequired } from '../../form';
import { useForm } from 'react-typed-form';
import { useNavigate } from 'react-router';

type Props = {
  email: string;
};

type ForgotPasswordManualEntryForm = {
  code: string;
};

export default function ForgotPasswordManualEntryForm({ email }: Props) {
  const navigate = useNavigate();

  const form = useForm<ForgotPasswordManualEntryForm>({
    defaultValues: {
      code: '',
    },
    onSubmit: async (values) => {
      navigate(
        `/reset-password?email=${encodeURIComponent(email)}&token=${encodeURIComponent(values.code)}`,
      );
    },
  });

  return (
    <form
      onSubmit={(ev) => {
        ev.preventDefault();
        form.handleSubmit();
      }}
    >
      <Card>
        <CardHeader title="Enter code manually" />
        <CardContent>
          <Stack spacing={2}>
            <Typography>
              Please provide the code you received by email
            </Typography>
            <FieldTextRequired label="Code" field={form.getField('code')} />
            <Button variant="contained" type="submit" disabled={form.isLoading}>
              Submit
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </form>
  );
}
